import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import { ROOT, BUILDING_PAGE, ELEVATOR_PAGE, DIMENSIONS_PAGE, PRODUCTS, OVERVIEW, SUCCESS } from './routes';

// const StartPage = React.lazy(() => import('../pages/StartPage/StartPage'));
// const BuildingPage = React.lazy(() => import('../pages/BuildingPage/BuildingPage'));
// const ElevatorPage = React.lazy(() => import('../pages/ElevatorPage/ElevatorPage'));
// const DimensionsPage = React.lazy(() => import('../pages/DimensionsPage/DimensionsPage'));
// const ProductsPage = React.lazy(() => import('../pages/ProductsPage/ProductsPage'));
// const ProductDetail = React.lazy(() => import('../pages/ProductDetail/ProductDetail'));
// const OverviewPage = React.lazy(() => import('../pages/OverviewPage/OverviewPage'));
// const SuccessPage = React.lazy(() => import('../pages/SuccessPage/SuccessPage'));

import StartPage from '../pages/StartPage/StartPage';
import BuildingPage from '../pages/BuildingPage/BuildingPage';
import ElevatorPage from '../pages/ElevatorPage/ElevatorPage';
import DimensionsPage from '../pages/DimensionsPage/DimensionsPage';
import ProductsPage from '../pages/ProductsPage/ProductsPage';
import ProductDetail from '../pages/ProductDetail/ProductDetail';
import OverviewPage from '../pages/OverviewPage/OverviewPage';
import SuccessPage from '../pages/SuccessPage/SuccessPage';


// ROUTES

const AppNavigation = () => {
	const location = useLocation();
	return (
		<AnimatePresence exitBeforeEnter>
			<Routes location={location} key={location.pathname} initial={false} >
				<Route path={ROOT} element={<StartPage />} />

				<Route path={BUILDING_PAGE} element={<BuildingPage />} />
				<Route path={`${BUILDING_PAGE}/:id`} element={<BuildingPage />} />

				<Route path={ELEVATOR_PAGE} element={<ElevatorPage />} />
				<Route path={`${ELEVATOR_PAGE}/:id`} element={<ElevatorPage />} />

				<Route path={DIMENSIONS_PAGE} element={<DimensionsPage />} />
				<Route path={`${DIMENSIONS_PAGE}/:id`} element={<DimensionsPage />} />

				<Route path={PRODUCTS} element={<ProductsPage />} />
				<Route path={`${PRODUCTS}/:id`} element={<ProductsPage />} />
				<Route path={`${PRODUCTS}/:id/:productSlug`} element={<ProductDetail />} />

				<Route path={OVERVIEW} element={<OverviewPage />} />

				<Route path={SUCCESS} element={<SuccessPage />} />

				<Route path='*' element={<Navigate to={ROOT} />} />
			</Routes>
		</AnimatePresence>
	);
};

export default AppNavigation;
